<template>
    <div class="container-wrap">
        <div class="graph-content" ref='graph'>
        </div>
        <div v-if="isFull" @click="fullGraph" class="full">{{fullType?'Exit':'Full'}}</div>
        <el-select v-model="isShowCompany" class="company-select" v-if="isCompany"
                   @change="changeShowCompany">
            <el-option v-for="(item, index) in showCompanyList" :key="index"
                       :label="item.label"
                       :value="item.value"></el-option>
        </el-select>
    </div>
</template>

<script>
import {
  baseUrl
} from '@/common/js/http/pdBase'
import * as _ from 'lodash'
import {getToken} from 'common/js/http/pdAxios'

export default {
  name: 'radialGraph',
  props: {
    value: {
      type: Object,
      default: () => {
        return {}
      }
    },
    hasLegend: {
      type: Boolean,
      default: true
    },
    isAll: {
      type: Boolean,
      default: true
    },
    isFocus: {
      type: Boolean,
      default: true
    },
    isFull: { // 是否有全屏按钮
      type: String,
      default: ''
    },
    isRealFull: { // 是否使用自己的全屏功能
      type: Boolean,
      default: true
    },
    schema: {
      type: String
    },
    isCompany: {
      type: Boolean,
      default: false
    },
    isRollZomm: {
      type: Boolean,
      default: false
    },
    // 是否开启右键菜单
    isContextmenu: {
      type: Boolean,
      default: false
    },
    isLayout: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      isShowCompany: 0,
      showCompanyList: [
        {
          label: '相关专利',
          value: 0
        },
        {
          label: '相关企业',
          value: 1
        }
      ],
      fullType: false,
      clickEvent: null,
      pageValue: {
        pageCount: this.value.pageCount,
        page: this.value.page,
        size: this.value.size
      },
      graph: null,
      settings: {
        ajaxSettings: {
          // baseUrl: 'http://192.168.4.31/plantdata-sdk/api/sdk/',
          baseUrl: baseUrl + '/',
          headers: {
            // APK: '37df4b42bf6442ae8dd263c731dccb6b'
          },
          queryData: {
            p: 'spa_pc_graph'
          }
        },
        schemaSettings: {
          ajaxSettings: {
            url: this.schema || baseUrl + '/ensearch/schema',
            type: 'POST',
            data: {},
            dataFilter: (data) => {
              const _data = JSON.parse(data)
              let arr = []
              const schemaArr = [
                '国家', '城市', '省份', '人物', '关键词', '组织机构',
                '新华丝路情报', '智讯参考', '投资风险周报', '投资风险报告', '公共安全报告']
              _.forEach(schemaArr, (key) => {
                const _item = _.find(_data.data.types, {'v': key})
                _item && arr.push(_item)
              })
              arr.push(..._data.data.types)
              arr = _.uniqBy(arr, 'v')
              _data.data.types = arr
              data = JSON.stringify(_data)
              return data
            }
          }
        },
        showLinkInfoOnClick: false,
        'attValueRule': {
          'enable': false,
          'settings': {
            'box': {
              'isOpen': false
            }
          }
        },
        contextmenu: {
          enable: this.isContextmenu,
          settings: {
            menu: {
              jumpSearch: {
                settings: {
                  title: 'Jump to search',
                  click: (a, b, c) => {
                    // console.log(b)
                    this.$emit('contextmenuClick', b)
                  },
                  customEnable: (data) => {
                    const isNodes = data.nodes && data.nodes.length && data.nodes[0]
                    return isNodes && !(isNodes.classIdList.indexOf(4) !== -1)
                  }
                }
              },
              jumpSearchDetail: {
                settings: {
                  title: 'Jump to details',
                  click: (a, b, c) => {
                    // console.log(b)
                    this.$emit('contextmenuClick', b)
                  },
                  customEnable: (data) => {
                    const isNodes = data.nodes && data.nodes.length && data.nodes[0]
                    return isNodes && (isNodes.classIdList.indexOf(4) !== -1)
                  }
                }
              }
            },
            items: ['jumpSearch', 'jumpSearchDetail']
          }
        },
        infoboxSettings: {
          settings: {
            ajaxSettings: {
              formData: {
                isRelationAtts: false
              }
            }
          }
        },
        // kgName: 'plantdata_bj73pdk7_graph_17332e734da',
        kgName: '',
        netChartSettings: {
          rightPanel: {
            mode: 'fixed',
            active: false
          },
          main: {
            events: {
              // onClick: (event, arg) => {
              //   if (this.clickEvent) {
              //     clearTimeout(this.clickEvent)
              //   }
              //   this.clickEvent = setTimeout(() => {
              //     this.$emit('changeGraph', event, arg)
              //   }, 500)
              // },
              onDoubleClick: (event, arg) => {
                if (this.clickEvent) {
                  clearTimeout(this.clickEvent)
                }
                this.clickEvent = setTimeout(() => {
                  this.$emit('doubleClick', arg.clickItem)
                }, 500)
              }
            }
          }
        },
        nodeLegend: {
          enable: this.hasLegend,
          settings: {
            events: {
              // click: (event) => {
              // },
              // dblclick: () => {
              // }
            }
          }
        },
        linkLegend: {
          settings: {
            color: [
              '#7bc0e1',
              '#9ec683',
              '#fde14d',
              '#ab89f4',
              '#FAC9B8',
              '#dca8c6',
              '#596690',
              '#eaad84',
              '#abe8bf',
              '#7979fc',
              '#FF6F5E',
              '#FFAF5E',
              '#D4B311',
              '#B4D411',
              '#73D411',
              '#11D4B3',
              '#11B3D4',
              '#1152D4',
              '#9311D4'
            ]
          }
        },
        pluginsSettings: {
          settings: {
            size: 'sm'
          }
        },
        promptSettings: {
          ajaxSettings: {
            queryData: {
              isInherit: true,
              openExportDate: true
            }
          }
        },
        showAllSchemaOptions: true,
        timeChart: {
          settings: {
            settings: {
              color: [
                '#5677fc'
              ],
              dataZoom: [
                {
                  fillerColor: 'rgba(57, 141, 238, .3)'
                }
              ]
            },
            dialogSettings: {
              defaultTimeFilterSettings: {
                1: {
                  fixedLinks: true,
                  fixedNodes: true,
                  noTimeLinks: false,
                  noTimeNodes: true
                },
                2: {
                  fixedLinks: true,
                  fixedNodes: true,
                  noTimeLinks: true,
                  noTimeNodes: false
                },
                3: {
                  fixedLinks: true,
                  fixedNodes: true,
                  noTimeLinks: true,
                  noTimeNodes: true
                }
              },
              defaultTimeFilterType: '2',
              rule: {
                1: {
                  fixedLinks: false,
                  fixedNodes: false,
                  noTimeLinks: false,
                  noTimeNodes: false
                },
                2: {
                  fixedLinks: false,
                  fixedNodes: false,
                  noTimeLinks: false,
                  noTimeNodes: false
                },
                3: {
                  fixedLinks: false,
                  fixedNodes: false,
                  noTimeLinks: false,
                  noTimeNodes: false
                }
              }
            }
          }
        },
        snapshot: {
          enable: false
        },
        selector: '.graph-content',
        loaderSettings: {
          ajaxSettings: {
            formData: {
              hyponymyDistance: 0
            }
          }
        },
        page: {
          enable: false
        },
        toolbar: {
          enable: this.isRollZomm,
          settings: {
            menu: {
              fullscreen: {
                enable: false
              },
              export: {
                enable: false
              },
              dragSelect: {
                enable: false
              },
              hoverHighlight: {
                enable: false
              },
              overview: {
                enable: false
              }
            }
            // items: ['back']
          }
        },
        changeLayout: {
          enable: this.isLayout,
          settings: {
            layout: this.value.layout || 'static',
            sankey: false
          }
        },
        find: {
          enable: false
        },
        history: {
          enable: false
        },
        wordCloudView: {
          enable: false
        },
        relativeFiles: {
          enable: false
        },
        visConfigure: {
          enable: false
        },
        filter: {
          enable: true,
          settings: {
            editItemSettings: [
              {
                key: 'isRelationMerge',
                label: '关系展示合并',
                value: 'true',
                options: [
                  {
                    label: '合并',
                    value: 'true'
                  },
                  {
                    label: '不合并',
                    value: 'false'
                  }
                ]
              },
              {
                key: 'hyponymyDistance',
                disabled: true
              },
              {
                'key': 'distance',
                'options': [
                  '1',
                  '2',
                  '3',
                  '4',
                  '5',
                  '6'
                ],
                'value': '1'
              },
              {
                'key': 'allowTypes',
                'index': 1
              },
              {
                'key': 'allowAtts',
                'index': 1
              },
              {
                'key': 'distance-expend',
                'index': 2
              }
            ]
          }
        },
        'prompt': {
          'enable': false,
          'settings': {
            'side': 'left',
            'promptSettings': {
              'autocompleteSettings': {
                'keyword': true
              }
            }
          }
        },
        infobox: {
          enable: false,
          settings: {
            active: true
          }
        },
        resetLayout: {
          enable: true
        },
        wordCloud: {
          enable: false
        },
        advancedPrompt: {
          enable: false
        },
        tagView: {
          enable: false
        },
        zoomSlider: {
          enable: this.isRollZomm
        }
      },
      nodeLegendStatus: []
    }
  },
  watch: {
    'value.graph': {
      handler (to, from) {
        if (!this.graph) {
          this.init(() => {
            this.updateGraph()
          })
        } else {
          this.updateGraph()
        }
      },
      deep: true
    }
  },
  methods: {
    init (fun) {
      !window.allToken && getToken()
      this.settings.ajaxSettings.headers['api-token'] = window.allToken
      if (window.PdLanguage && window.PdSDKDcGraph && !this.graph) {
        window.PdLanguage.setLanguage({
          plugin: {
            resetLayout: {
              resetLayout: 'Reset layout'
            },
            changeLayout: {
              changeLayout: 'Change layout',
              force: 'Dynamic layout',
              horizontalLine: 'Horizontal layout',
              layout: 'layout',
              leftTree: 'Left tree layout',
              pack: 'Package layout',
              partition: 'Partition layout',
              radial: 'Radial layout',
              radialForce: 'Radial force layout',
              ring: 'Circular layout',
              reverseTree: 'Reverse tree layout',
              rightTree: 'Right tree layout',
              sankey: 'Sangji layout',
              static: 'Static layout',
              tree: 'Tree layout',
              treemap: 'Rectangle tree layout',
              verticalLine: 'Vertical layout'
            }
          }

        })
        this.graph = new PdSDKDcGraph(this.settings)
        console.log(this.graph)
        this.graph.on('inited', () => {
          if (this.isAll) {
            this.draw()
          }
          this.graph.netChart.on('click', (event, arg) => {
            if (!event.clickNode) return
            if (this.clickEvent) {
              clearTimeout(this.clickEvent)
            }
            event.clickNode.title = event.clickNode.name
            event.clickNode.data = {conceptName: event.clickNode.conceptName}
            event.clickItem = event.clickNode
            this.clickEvent = setTimeout(() => {
              this.$emit('changeGraph', null, event)
            }, 500)
          })
          fun && fun()
        })
      } else {
        clearTimeout(window.newGraph)
        window.newGraph = setTimeout(() => {
          if (window.newGraph !== 15) {
            this.init(fun)
          }
        }, 1000)
      }
    },
    updateGraph () { // 更新图谱
      // debugger
      this.$nextTick(() => {
        // debugger
        if (this.value.graph) {
          let focus = null
          if (this.isFocus) {
            if (this.value.graph.entityList && this.value.graph.entityList.length) {
              focus = this.value.graph.entityList[0]
            }
          }
          this.pageValue.pageCount = this.value.pageCount
          const graph = _.cloneDeep(this.value.graph)
          this.graph.netChart.historyList = []
          this.graph.netChart.historyCursor = -1
          this.graph.netChart.addData(graph, focus)
        }
      })
    },
    changeSize (val) { // 切换每页的个数
      this.$emit('changePage', 'PageSize', val)
    },
    jumpList (val) { // 翻页
      this.$emit('changePage', 'pageNum', val)
    },
    // 探索
    addNode (id, node) {
      this.graph.netChart.addData(node, {id: id, $source: 'dblClick'})
    },
    // 重绘方法
    draw () {
      this.graph.netChart.on('beforedraw', () => {
        setTimeout(() => {
          // this.graph.changeLayout.updateLayout(this.settings.changeLayout.settings.layout)
          this.graph.netChart.fitPanel()
        }, 1000)
      })
    },
    fullGraph () {
      if (this.isRealFull) {
        this.fullType = !this.fullType
        const parent = $(`${this.isFull}`)
        if (this.fullType) {
          parent.addClass('pd-graph-full-style')
        } else {
          parent.removeClass('pd-graph-full-style')
        }
      } else {
        this.$emit('fullGraph')
      }
      setTimeout(() => {
        // this.graph.changeLayout.updateLayout(this.settings.changeLayout.settings.layout)
        this.graph.netChart.fitPanel()
      }, 900)
    },
    changeShowCompany () {
      this.$emit('changeCompany', this.isShowCompany)
    },
    PdJumpSearch () {
      const node = window.clickpdNode
      console.log(node)
      this.jumpSearch(node)
    }
    // handleNodeLegend (data) {
    //   if (this.nodeLegendStatus.length) {
    //     const arr = this.differenceLegend(data.legends, this.nodeLegendStatus, 'hidden')
    //     // 存在更改
    //     if (arr) {
    //       // const id = arr.key.split('-')
    //       // this.handleGraphNode(id[1], !arr.hidden)
    //     }
    //     this.nodeLegendStatus = data.legends
    //   } else {
    //     this.nodeLegendStatus = data.legends
    //   }
    // },
    // 更具图例对比 节点影藏开放节点
    // handleGraphNode (id, type, key = 'classId') {
    //   // debugger
    //   const data = this.graph.netChart.getAvailableData()
    //   const nodeId = []
    //   if (key === 'classId') {
    //     data.nodes.forEach(item => {
    //       if (item[key] === id) {
    //         item.visible = type
    //         nodeId.push(item.id)
    //       }
    //     })
    //   } else {
    //     this.graph.netChart.getNode(id).visible = false
    //   }
    //   const newNodeId = []
    //   data.links.forEach(item => {
    //     if (nodeId.indexOf(item.from) !== -1 || nodeId.indexOf(item.to) !== -1) {
    //       item.visible = type
    //       if (!type) {
    //         newNodeId.push(item.to)
    //       }
    //     }
    //   })
    //   if (newNodeId.length) {
    //     newNodeId.forEach((_id) => {
    //       this.handleGraphNode(_id, type, 'id')
    //     })
    //   }
    //   this.graph.netChart.updateStyle()
    // },
    // differenceLegend (newData, oldData, type) {
    //   for (let i = 0; i < newData.length; i++) {
    //     if (newData[i][type] !== oldData[i][type]) {
    //       return newData[i]
    //     }
    //   }
    //   return null
    // }
  },
  destroyed () {
    clearInterval(window.newGraph)
  }
}
</script>

<style lang="less">
    .pd-graph-full-style {
        position: fixed !important;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        height: 100vh !important;
        width: 100vw !important;
        z-index: 1000;
    }

    .container-wrap {

        .graph-content {
            width: 100%;
            height: 100%;

            .pd-panel-right {
                display: none;
            }

            .pdvis-toolbar-md {
                bottom: 151px !important;
                transform: translateX(110%);
            }
        }

        .plantdata-ns .pd-panel-overlay:not(:empty).pd-panel-right ~ .pd-panel-float-top {
            margin-right: 0;
        }

        .plantdata-ns .pdvis-edit-item-select {
            background: #ffffff;
        }

        .plantdata-ns .pdvis-change-layout-container select {
            height: 30px;
        }

        .pdvis-reset-layout-container .pdvis-float-item-head .pd-panel-tooltip {
            height: 30px;
            line-height: 30px;
        }

        .plantdata-ns .pd-panel-main > .pd-panel-tabs {
            border: none !important;
        }

        .pd-panel-float .pd-panel-float-item {
            font-size: 14px !important;
            border-color: rgb(220, 223, 230) !important;
        }

        .pd-panel-float .pdvis-float-item-head {
            border-color: rgb(220, 223, 230) !important;
        }
    }
</style>

<style lang="less" scoped>

    .container-wrap {
        width: 100%;
        height: 100%;
        position: relative;
    }

    .page-container {
        position: absolute;
        top: 0;
        right: 178px;
        z-index: 99;
    }

    .graph-content {
        background: #ffffff !important;

        /deep/ .pd-panel-float {
            margin: 0;
        }

        /deep/ .pdvis-change-layout-container, /deep/ .pdvis-reset-layout-container .pdvis-float-item-head {
            box-shadow: none;
            border: 1px solid rgba(0, 0, 0, 0.1);
            padding: 0;
            font-size: 12px;
        }

        /deep/ .pdvis-reset-layout-container {
            .pdvis-float-item-head {
                height: 32px;
                width: 32px;
                display: flex;
                justify-content: center;
                align-items: center;

                .pd-panel-icon {
                    width: 26px;
                    height: 26px;
                    margin-left: 5px;
                    padding: 1px 0 !important;
                }

                .pd-panel-tooltip {
                    font-size: 12px;
                    line-height: 32px;
                    height: 32px;
                    display: none;
                }
            }
        }

        /deep/ .pdvis-zoom-slider-container {
            right: -29px;
            bottom: 32px !important;

            .pdvis-slider-bar {
                background: #0a75be !important;

            }

            .pdvis-slider-button {
                border-color: #0a75be !important;
            }
        }
    }

    .full {
        position: absolute;
        bottom: 5px;
        right: 20px;
        color: #007bff;
        cursor: pointer;
        z-index: 9;
        padding: 2px;
        background: #fff;
        border-radius: 2px;
        transform: translateX(2px);
    }

    .company-select {
        position: absolute;
        top: 16px;
        right: 239px;
        width: 130px;
        z-index: 2;

        /deep/ .el-input__icon {
            font-size: 12px;
            color: #666666;
        }
    }

    /deep/ .active {
        border-bottom: none !important;
    }

    /deep/ .pdvis-change-layout-container select {
        width: 100px;
    }

    @media screen and (max-width: 769px) {
        .full {
            display: none !important;
        }
    }
</style>
